import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import Home from './components/pages/Home';
import Create from './components/pages/Create';
import Template from './components/pages/Template';
import About from './components/pages/About';
import Success from './components/pages/Success';
import Pricing from './components/pages/Pricing';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
      <Switch>
          <Route exact path='/' component={Home} />
          <Route exact path='/create' component={Create} />
          <Route exact path='/about' component={About} />
          <Route exact path='/pricing' component={Pricing} />
          <Route path='/design/:id' component={Success} />
          <Route path='/template/:id' component={Template} />
      </Switch>
      </div>
    </BrowserRouter>
  );
}

export default App;
